import { useIntl } from "react-intl";

import ImageChecklistSide, {
    ListItemWithEmphsis
} from "../../../../../../../../patterns/image-checklist-side";

const Operations = () => {
    const intl = useIntl();

    const title = intl.formatMessage({
        id: "JiraSoftwarePage.PaidLpJswPm.operations.headerText",
        defaultMessage: "Operations"
    });

    const stayAStepAhead = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.operations.stayAStepAhead.strongtext",
            defaultMessage: "Stay a step ahead:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.operations.stayAStepAhead.plainText",
            defaultMessage:
                " Don't let last-minute supply problems catch you by surprise. Monitor and plan purchase dates and inventory to keep the lights on and inventory stocked."
        })
    };

    const processesLockedIn = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.operations.processesLockedIn.strongtext",
            defaultMessage: "Make processes as locked-in as you are:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.operations.processesLockedIn.plainText",
            defaultMessage:
                " Operations teams shine when they refine their own processes. Experiment and improve your workflows to see which process wins out in the end. Then scale it up to meet your entire organization's needs."
        })
    };

    const inTakeProcess = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.operations.inTakeProcess.strongtext",
            defaultMessage: "Build an intake process, fast:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.operations.inTakeProcess.plainText",
            defaultMessage:
                " Set up a custom form in seconds and give employees one place to submit simple requests for new items and inventory. Save yourself hours and make procurement simpler to manage."
        })
    };

    const listItems = [
        ListItemWithEmphsis(stayAStepAhead),
        ListItemWithEmphsis(processesLockedIn),
        ListItemWithEmphsis(inTakeProcess)
    ];
    const imageSrc =
        "https://wac-cdn.atlassian.com/dam/jcr:6f1e5066-4b58-4a8d-82bd-48a3133eb70d/OPERATIONS@2x.png?cdnVersion=ece";
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePage.PaidLpJswPm.operations.tabsImageAltText",
        defaultMessage: "Operations"
    });

    const testimony = {
        isIncludeTestimony: true,
        quoteBlurb: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.operations.testimony.quoteBlurb",
            defaultMessage:
                "The biggest benefit of consolidating our platform on Atlassian products has been providing a single point of visibility over our projects. Now we can see what everybody else is doing, and understand each project’s status in great detail."
        }),
        quoteName: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.operations.testimony.quoteName",
            defaultMessage: "DANIELE FARNEDI"
        }),
        quoteCompany: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.operations.testimony.quoteCompany",
            defaultMessage: "CTO, TRULIA"
        }),
        testimonyImageClassName: "tab-testimony-image",
        testimonyImageSrc:
            "https://wac-cdn.atlassian.com/dam/jcr:d66652e7-fc88-41ca-ab57-630507d62391/LP-logos_trulia%20logo.svg?cdnVersion=ece",
        testimonyImageAlt: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.operations.testimony.logo.imageAltText",
            defaultMessage: "Trulia Logo"
        })
    };

    return (
        <ImageChecklistSide
            title={title}
            listItems={listItems}
            imageSrc={imageSrc}
            imageAlt={imageAlt}
            isIncludeTestimony={testimony.isIncludeTestimony}
            quoteBlurb={testimony.quoteBlurb}
            quoteName={testimony.quoteName}
            quoteCompany={testimony.quoteCompany}
            testimonyImageClassName={testimony.testimonyImageClassName}
            testimonyImageSrc={testimony.testimonyImageSrc}
            testimonyImageAlt={testimony.testimonyImageAlt}
        />
    );
};

export default Operations;
